import { FortuneOfWarCardInfo, KingdomName, TileInfoProps } from "./types";

export const colourToKingdomMap: Record<string, KingdomName> = {
  "#DC5454": "Angland",
  "#51658D": "Gallois",
  "#F5DE48": "Castillia",
  // "#FE9F10":"Zeeland",
  // "#FE9ACC":"Venoa",
  "#A0522D": "Nordmark",
  "#E6EFE9": "Ostreich",
  "#478779": "Constantium",
};

export const unknownWorldTiles: TileInfoProps[] = [
  {
    name: "Dwarves1",
    blocked: ["N", "NE", "NW"],
    sword: 10,
    shield: 11,
    type: "land",
    loot: {
      outpost: {
        gold: 2,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 3,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Dwarves2",
    blocked: ["E", "SE"],
    sword: 8,
    shield: 9,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Dwarves3",
    blocked: ["E"],
    sword: 10,
    shield: 11,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 2,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Elves1",
    blocked: ["NW"],
    sword: 17,
    shield: 8,
    type: "land",
    loot: {
      outpost: {
        gold: 2,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 3,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Elves2",
    blocked: [],
    sword: 14,
    shield: 7,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 2,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Elves3",
    blocked: [],
    sword: 11,
    shield: 6,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Goblins1",
    blocked: [],
    sword: 10,
    shield: 7,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 3,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 2,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 2,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Goblins2",
    blocked: ["NE"],
    sword: 8,
    shield: 5,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 2,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 2,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Goblins3",
    blocked: ["W"],
    sword: 6,
    shield: 3,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 1,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 1,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Halflings1",
    blocked: [],
    sword: 7,
    shield: 10,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 3,
        victoryPoints: 0,
      },
      colony: {
        gold: 2,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 2,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Halflings2",
    blocked: [],
    sword: 5,
    shield: 8,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 2,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 2,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Halflings3",
    blocked: [],
    sword: 3,
    shield: 6,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 1,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 1,
        victoryPoints: 0,
      },
    },
  },

  {
    name: "Orcs1",
    blocked: ["NE"],
    sword: 16,
    shield: 5,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 2,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 2,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 2,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Orcs2",
    blocked: ["NW"],
    sword: 10,
    shield: 3,
    type: "land",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 1,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 1,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Orcs3",
    blocked: [],
    sword: 13,
    shield: 4,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 1,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 2,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Trolls1",
    blocked: ["W"],
    sword: 11,
    shield: 10,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 2,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 2,
        mithril: 0,
        dragonScales: 2,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Trolls2",
    blocked: ["SW"],
    sword: 9,
    shield: 8,
    type: "land",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 1,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 2,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Trolls3",
    blocked: ["NE"],
    sword: 6,
    type: "land",
    shield: 3,
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 1,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 1,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
];
export const oceanTiles: TileInfoProps[] = [
  {
    name: "Ocean1",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "ocean",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Ocean2",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "ocean",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Ocean3",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "ocean",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "Ocean4",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "ocean",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
];
export const legendTiles: TileInfoProps[] = [
  {
    name: "HereBeDragons",
    blocked: ["S", "SE"],
    sword: 0,
    shield: 0,
    type: "legend",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 1,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 1,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "SeaElves",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "legend",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 1,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "TheFountainOfYouth",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "legend",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 2,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 2,
      },
    },
  },
  {
    name: "TheKingdomOfTheMerfolk",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "legend",
    loot: {
      outpost: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 1,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 1,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "TheKraken",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "legend",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 2,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 2,
      },
    },
  },
  {
    name: "TheLostCityOfGold",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "legend",
    loot: {
      outpost: {
        gold: 1,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 1,
        mithril: 1,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
];

export const knownWorldTiles: TileInfoProps[] = [
  {
    name: "KnownWorld1",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "ocean",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "KnownWorld2",
    blocked: ["E", "SE"],
    sword: 0,
    shield: 0,
    type: "home",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "KnownWorld3",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "ocean",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
  {
    name: "KnownWorld4",
    blocked: [],
    sword: 0,
    shield: 0,
    type: "infidel_empire",
    loot: {
      outpost: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
      colony: {
        gold: 0,
        mithril: 0,
        dragonScales: 0,
        krakenSkin: 0,
        magicDust: 0,
        stickyIchor: 0,
        pipeweed: 0,
        victoryPoints: 0,
      },
    },
  },
];

export const fortuneOfWarCards: FortuneOfWarCardInfo[] = [
  {
    name: "SwordOne",
    sword: 1,
    shield: 0,
  },
  { name: "SwordTwo", sword: 2, shield: 0 },
  { name: "SwordThree", sword: 3, shield: 0 },
  { name: "SwordFour", sword: 4, shield: 0 },
  { name: "SwordFive", sword: 5, shield: 0 },
  { name: "ShieldFour", sword: 0, shield: 4 },
  { name: "ShieldFive", sword: 0, shield: 5 },
  { name: "ShieldSix", sword: 0, shield: 6 },
  { name: "ShieldSeven", sword: 0, shield: 7 },
  { name: "ShieldEight", sword: 0, shield: 8 },
  { name: "NoEffect", sword: 0, shield: 0 },
];
